import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
// import "./index.scss";
import "./index.css";
import "./assets/scss/_Font.scss";
import "./assets/scss/_Style.scss";
import "./assets/scss/_Style2.scss";
import "./assets/scss/_Responsive.scss";
import Root from "./Routes/Routes.dev";
import { UserContextProvider } from "./utils/hooks/UserContext";
import { SidebarProvider } from "./utils/context/SidebarContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
if (process.env.NODE_ENV === "development" && typeof window !== "undefined") {
  window.addEventListener("error", (e) => {
    const msg = e?.message || "";
    if (msg.includes("ResizeObserver loop completed with undelivered notifications")) {
      e.stopImmediatePropagation();
    }
  });
}
root.render(
  <BrowserRouter>
    <UserContextProvider>
      <SidebarProvider>
        <Root />
      </SidebarProvider>
    </UserContextProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
